import { useState } from "react"

import { TextField, Button, Stack, Typography, Switch } from "@mui/material"


const RequestForm = ({ messages, reply }) => {

  const [message, setMessage] = useState("")
  const [messageError, setMessageError] = useState("")
  const [close, setClose] = useState(false)

  const validate = () => {
    const trimmedMessage = message.trim()
    if (trimmedMessage.length <= 2) {
      setMessageError("Message must be longer than 2 characters.")
      return false
    }
    setMessageError("")
    return true
  }

  const submit = () => {
    if (!validate()) {
      return
    }
    reply({ message, close })
  }

  if (messages.length) return (
    <div className="w-3/4 self-start -mt-5">
    <div>
      <div className="flex flex-row justify-end p-5">

        <TextField
          value={message}
          onChange={e => {
            setMessage(e.target.value)
            if (messageError) {
              setMessageError("")
            }
          }}
          onBlur={validate}
          fullWidth
          multiline
          minRows={10}
          required={true}
          label="reply"
          error={Boolean(messageError)}
          helperText={messageError}
          slotProps={{ inputLabel: { shrink: true } }}
        />
      </div>

      <div className="flex flex-row justify-end">

        <div className="flex flex-row gap-5 p-5">
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
            <Typography>Close thread : no</Typography>
            <Switch checked={close} onChange={e => setClose(e.target.checked)} />
            <Typography>yes</Typography>
          </Stack>

          <Button onClick={submit} variant="contained">Send Reply</Button>
        </div>
      </div>

    </div>
    </div>
  )
}

export default RequestForm
